import React from "react";
import "./CategorySidebar.scss";

interface CategorySidebarProps {
  categories: string[];
  activeCategory: string;
  onCategorySelect: (category: string) => void;
}

const CategorySidebar: React.FC<CategorySidebarProps> = ({
  categories,
  activeCategory,
  onCategorySelect,
}) => {
  return (
    <ul className="category-sidebar-list">
      {categories.map((category) => (
        <li
          key={category}
          className={`category-item ${activeCategory === category ? "active" : ""}`}
          onClick={() => onCategorySelect(category)}
        >
          {category}
        </li>
      ))}
    </ul>
  );
};

export default CategorySidebar;

